import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';

import { IEmployeeLight } from '../../types/employee';

import { Icons } from '../icons';
import { UtilityService } from '../../services/utilityService';
import { Button } from '@mui/material';

export interface IEmployeeTableProps {
	data?: IEmployeeLight[];
}

const EmployeeTable: React.FunctionComponent<IEmployeeTableProps> = ({ data }) => {
	const [dataView, setDataView] = useState<IEmployeeLight[]>([]);
	const [firstVisibleRow, setFirstVisibleRow] = useState(0);
	const [lastVisibleRow, setLastVisibleRow] = useState(9);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState("fname");
	const [sortAscending, setSortAscending] = useState(true);

	const handleHeaderClick = (field: string) => {
		if (sortField == field) {
			setSortAscending(!sortAscending);
		}
		else {
			setSortAscending(true);
			setSortField(field);
		}
	}

	useEffect(() => {
		if (data) {
			let newData = data.slice();

			if (sortField) {
				switch (sortField) {
					case "fname": {
						newData.sort((a, b) => UtilityService.compareStrings(a.firstName, b.firstName));
						break;
					}
					case "lname": {
						newData.sort((a, b) => UtilityService.compareStrings(a.lastName, b.lastName));
						break;
					}
					case "uname": {
						newData.sort((a, b) => UtilityService.compareStrings(a.username, b.username));
						break;
					}
					case "phone": {
						newData.sort((a, b) => UtilityService.compareStrings(a.phone, b.phone));
						break;
					}
					case "email": {
						newData.sort((a, b) => UtilityService.compareStrings(a.email, b.email));
						break;
					}
					case "status": {
						newData.sort((a, b) => UtilityService.compareStrings(a.status?.toString(), b.status?.toString()));
						break;
					}
					default: {
						newData.sort((a, b) => UtilityService.compareStrings(a.firstName, b.firstName));
						break;
					}
				}

				if (!sortAscending) newData.reverse();

				setDataView(newData);
				setFirstVisibleRow(0);
				setLastVisibleRow(pageSize - 1);
			}
		}
	}, [data, sortField, sortAscending])

	const handlePageBack = () => {
		setFirstVisibleRow(firstVisibleRow - pageSize);
		setLastVisibleRow(lastVisibleRow - pageSize);
	}

	const handlePageForward = () => {
		setFirstVisibleRow(firstVisibleRow + pageSize);
		setLastVisibleRow(lastVisibleRow + pageSize);
	}

	return (
		<div className="hwi-entity-search-results-table">
			<div className="headers">
				<div className="first-name-col">
					<p onClick={() => handleHeaderClick("fname")}>
						First
						{" "}
						{(sortField == "fname" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "fname" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="last-name-col">
					<p onClick={() => handleHeaderClick("lname")}>
						Last
						{" "}
						{(sortField == "lname" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "lname" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="username-col">
					<p onClick={() => handleHeaderClick("uname")}>
						Username
						{" "}
						{(sortField == "uname" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "uname" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="phone-col">
					<p onClick={() => handleHeaderClick("phone")}>
						Phone
						{" "}
						{(sortField == "phone" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "phone" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="email-col">
					<p onClick={() => handleHeaderClick("email")}>
						Email
						{" "}
						{(sortField == "email" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "email" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				{/* <div className="status-col">
					<p onClick={() => handleHeaderClick("status")}>
						Status
						{" "}
						{(sortField == "status" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "status" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div> */}
				<div className="controls-col">{""}</div>
			</div>
			<div className="data">
				{dataView?.length > 0 ?
					(
						<>
							{dataView?.map((item, index) => (
								<div className={index >= firstVisibleRow && index <= lastVisibleRow ? "row" : "row row-hidden"} key={item.id}>
									<div className="first-name-col"><p>{item.firstName}</p></div>
									<div className="last-name-col"><p>{item.lastName}</p></div>
									<div className="username-col"><p>{item.username}</p></div>
									<div className="phone-col"><p>{item.phone}</p></div>
									<div className="email-col"><p>{item.email}</p></div>
									{/* <div className="status-col"><p>{item.status}</p></div> */}
									<div className="controls-col"><p>
										<NavLink to={"/employee/" + item.id}>
											<Icons.EditItem fill="#272f50" height="14px"></Icons.EditItem>
											{" "}
											Edit
										</NavLink>
									</p></div>
								</div>
							))}
						</>
					) : (<div className="no-results">0 results</div>)}
			</div>
			<div className="pager">
				<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={firstVisibleRow == 0 ? true : false} onClick={handlePageBack}>Previous</Button></div>
				<div className="pager-text">{`${firstVisibleRow + 1} to ${(lastVisibleRow + 1) <= dataView.length ? lastVisibleRow + 1 : dataView.length} of ${dataView.length}`}</div>
				<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={lastVisibleRow >= dataView.length - 1 ? true : false} onClick={handlePageForward}>Next</Button></div>
			</div>
		</div>
	)
}

export default EmployeeTable;